import { httpCreate } from './http';

const http = httpCreate('/srv/withdrawal');

export const withdrawal = {
	applyCash(params, data) {
		return http.post('/apply', data, { params });
	},
	applyWalletCash(params, data) {
		return http.post('/wallet/apply', data, { params });
	},
	applyMarkingCash(params, data) {
		return http.post('/marketing/apply', data, { params });
	},
	// http://{{twzb-url}}/srv/withdrawal/marketing/apply?mobPhone=18333180745&smsCode=839617
	// 获取银行卡信息
	getBankInfo(params) {
		return http.get('/boundInfo', { params });
	},
	//获取所有银行卡列表
	getBanklist() {
		return http.get('/bankList');
	},
	//绑定银行卡
	bindBank(params, data) {
		return http.post('/bindBank', data, { params });
	},
	//发送验证码
	sendCode(params) {
		return http.post('/checkVerifyCode', {}, params);
	},
};
